import React from 'react';
import PropTypes from 'prop-types';
import { Icon, IconFill, Svg, Circle, LightCircle } from './StatusIconStyledComponents';

function getIcon(status) {
  switch (status) {
    case 'success':
      return React.createElement(Icon, {
        status: status,
        fill: "none",
        d: "M30,50 46,65 70,33"
      });

    case 'fail':
      return React.createElement("g", null, React.createElement(Icon, {
        status: status,
        d: "M35,35 65,65"
      }), React.createElement(Icon, {
        status: status,
        d: "M35,65 65,35"
      }));

    case 'warn':
      return React.createElement("g", null, React.createElement(IconFill, {
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        d: "M30,62.5 70,62.5 50,28Z"
      }), React.createElement("path", {
        strokeWidth: "3",
        stroke: "#fff",
        strokeLinecap: "round",
        d: "M50,42 50, 50"
      }), React.createElement("circle", {
        fill: "#fff",
        cx: "50",
        cy: "56",
        r: "1.5"
      }));

    default:
      return React.createElement("g", null);
  }
}

function StatusIcon(_ref) {
  var color = _ref.color,
      countdown = _ref.countdown,
      status = _ref.status;
  return React.createElement("span", null, React.createElement(Svg, {
    status: status,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement(LightCircle, {
    cx: "50",
    cy: "50",
    r: "40"
  }), React.createElement(Circle, {
    color: color,
    countdown: countdown,
    status: status,
    d: "M50, 50 m0, -40 a40,40 0 0,1 0,80 a40,40 0 0,1 0,-80"
  }), getIcon(status)));
}

StatusIcon.propTypes = {
  color: PropTypes.string,
  countdown: PropTypes.number,
  status: PropTypes.oneOf(['pending', 'fail', 'success', 'warn'])
};
StatusIcon.defaultProps = {
  color: '',
  countdown: null,
  status: 'pending'
};
export default StatusIcon;